import { render } from "./CustomImage.vue?vue&type=template&id=76fa8840"
import script from "./CustomImage.vue?vue&type=script&lang=js"
export * from "./CustomImage.vue?vue&type=script&lang=js"

import "./CustomImage.vue?vue&type=style&index=0&id=76fa8840&lang=css"

import exportComponent from "/Users/ricpp/Development/boldbrush/blog_post_editor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__